// extracted by mini-css-extract-plugin
module.exports = {"tab":"Header_tab__3RSgr"};